import { useCallback } from "react";
import { ContextValue } from "components/bookShuffle/useBookShuffle/types";

export default function useSkip(context:ContextValue){
  const {dispatch, onSkip} = context

  context.setShowSkipConfirm = useCallback(
    (showSkipConfirm:boolean) => {
      dispatch({
        type:"updateState",
        payload:{
          showSkipConfirm
        },
      })
    },
    [dispatch]
  )

  context.handleSkip = useCallback(
    () => {
      onSkip?.();
    },
    [onSkip]
  )
}
